import { type Control, Controller, type UseFormRegister, useWatch } from 'react-hook-form'

import { YesNo } from '@/components/ui/button-group'
import { FieldError } from '@/components/ui/field-error'
import { Input } from '@/components/ui/input'
import type { Step4FormValues } from './claimStep4Values'

interface ClaimOtherVehiclesSectionProps {
  control: Control<Step4FormValues>
  register: UseFormRegister<Step4FormValues>
}

export function ClaimOtherVehiclesSection({ control, register }: ClaimOtherVehiclesSectionProps) {
  const involved = useWatch({ control, name: 'otherVehiclesInvolved' })

  return (
    <>
      <Controller
        name="otherVehiclesInvolved"
        control={control}
        rules={{ validate: (v) => v !== null || 'Please choose.' }}
        render={({ field, fieldState }) => (
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-neutral-700">Were other vehicles involved? *</label>
            <YesNo value={field.value} onChange={field.onChange} />
            <FieldError message={fieldState.error?.message} />
          </div>
        )}
      />

      {involved === true && (
        <div className="flex flex-col gap-4 border-t pt-4">
          <p className="text-xs font-semibold tracking-wide text-neutral-500 uppercase">Other vehicle #1</p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">License plate</label>
              <Input placeholder="Plate number" {...register('otherLicensePlate')} />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">Other driver name</label>
              <Input placeholder="Full name if available" {...register('otherDriverName')} />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">Their insurance company</label>
              <Input placeholder="Leave blank if unknown" {...register('otherInsuranceCompany')} />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">Their policy number</label>
              <Input
                placeholder="From their insurance card, if you have it"
                {...register('otherPolicyNumber')}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-neutral-700">Their contact info</label>
              <Input placeholder="Phone or email if available" {...register('otherContactInfo')} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
